(function () {
  var W = 854;
  var H = 650;
  var OX = 40;
  var OY = 130;
  var INK = '#090909';
  var DUSK_PAPER = {
    spring: '#dfc6c0',
    summer: '#e2c5a5',
    autumn: '#ddbea1',
    winter: '#d2c3cc'
  };

  var SEASONS = ['spring', 'summer', 'autumn', 'winter'];
  var SEASON_EN = { spring: 'SPRING', summer: 'SUMMER', autumn: 'AUTUMN', winter: 'WINTER' };
  var SEASON_JA = { spring: '春', summer: '夏', autumn: '秋', winter: '冬' };

  var house = null;
  var houseReady = false;
  var effects = null;
  var effectsReady = false;
  var instances = [];
  var dialTurns = null;
  var seasonMode = 'auto';
  var periodMode = 'auto';
  var season = 'spring';
  var period = 'day';
  var paper = '#efefef';
  var params = new URLSearchParams(window.location.search);
  var seasonParam = params.get('hut-season');
  var periodParam = params.get('hut-period');
  if (['spring', 'summer', 'autumn', 'winter'].indexOf(seasonParam) !== -1) seasonMode = seasonParam;
  if (['day', 'dusk', 'night'].indexOf(periodParam) !== -1) periodMode = periodParam;

  // A manually chosen season / time of day survives in-site navigation
  // (e.g. leaving TOP and returning via the header logo). URL params win.
  var SCENE_KEY = 'hut-living-scene';
  try {
    var storedScene = JSON.parse(sessionStorage.getItem(SCENE_KEY) || 'null');
    if (storedScene) {
      if (seasonMode === 'auto' && SEASONS.indexOf(storedScene.season) !== -1) {
        seasonMode = storedScene.season;
        if (typeof storedScene.turns === 'number' && isFinite(storedScene.turns)) dialTurns = storedScene.turns;
      }
      if (periodMode === 'auto' && ['day', 'dusk', 'night'].indexOf(storedScene.period) !== -1) {
        periodMode = storedScene.period;
      }
    }
  } catch (e) {
    /* ignore blocked storage */
  }

  function persistScene() {
    try {
      sessionStorage.setItem(SCENE_KEY, JSON.stringify({ season: seasonMode, period: periodMode, turns: dialTurns }));
    } catch (e) {
      /* ignore blocked storage */
    }
  }

  function clamp(x, a, b) {
    if (a === undefined) a = 0;
    if (b === undefined) b = 1;
    return Math.max(a, Math.min(b, x));
  }

  function smooth(x) {
    x = clamp(x);
    return x * x * (3 - 2 * x);
  }

  function updateSeason() {
    period = periodMode === 'auto' ? HutSeasons.periodForDate() : periodMode;
    season = seasonMode === 'auto' ? HutSeasons.seasonForDate() : seasonMode;
    if (dialTurns === null) dialTurns = SEASONS.indexOf(season);
    var c = HutSeasons.config[season];
    paper = period === 'dusk' ? DUSK_PAPER[season] : period === 'night' ? c.night : c.day;
    document.querySelectorAll('.hut-top-main').forEach(function (el) {
      el.style.setProperty('--hut-paper', paper);
      el.classList.toggle('is-day', period === 'day');
      el.classList.toggle('is-night', period === 'night');
      el.classList.toggle('is-dusk', period === 'dusk');
    });
    instances.forEach(function (inst) {
      inst.syncPeriod();
    });
  }

  function createInstance(root) {
    var canvas = root.querySelector('canvas');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var light = root.querySelector('.hut-light');
    var dialHit = root.querySelector('.hut-dial-hit');
    var live = root.querySelector('.hut-sr');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var state = {
      time: 0,
      paused: reduced.matches,
      night: false,
      gust: -100,
      nextGust: 4.5,
      sign: -100,
      smoke: -100,
      manualUntil: 0,
      dialAngle: null,
      dialLastT: 0,
      nudgeStart: -100,
      nextNudge: 6.5
    };
    var sceneCTM = null;
    var leftTree = [[0, 439], [0, 291], [90, 286], [96, 405]];
    var rightTree = [[656, 365], [656, 269], [731, 263], [734, 381]];
    var littleTree = [[724, 380], [723, 323], [767, 319], [774, 404]];
    // Outline-fitted CHAOS board. The previous pentagon sat outside the woodcut
    // stroke, so night fills leaked past the top and right edges.
    var signShape = [[554, 366], [631, 385], [636, 403], [617, 416], [556, 400]];
    var signFill = [[556, 367], [629, 385], [634, 402], [615, 414], [558, 400]];
    var bigChangeFill = [
      [527, 321],
      [547, 305],
      [555, 306],
      [636, 323],
      [644, 327],
      [628, 362],
      [623, 363],
      [542, 345]
    ];
    var teatimeFill = [[548, 435], [551, 423], [575, 415], [587, 413], [597, 417], [594, 430], [558, 442]];
    var last = 0;
    var raf = 0;
    var inView = true;
    var bareHouse = null;

    function announce(text) {
      if (live) live.textContent = text;
    }

    function polygon(points) {
      ctx.beginPath();
      points.forEach(function (p, i) {
        if (i) ctx.lineTo(p[0], p[1]);
        else ctx.moveTo(p[0], p[1]);
      });
      ctx.closePath();
    }

    function fillClipped(points, color) {
      var minX = points[0][0];
      var minY = points[0][1];
      var maxX = minX;
      var maxY = minY;
      var i;
      for (i = 1; i < points.length; i++) {
        if (points[i][0] < minX) minX = points[i][0];
        if (points[i][1] < minY) minY = points[i][1];
        if (points[i][0] > maxX) maxX = points[i][0];
        if (points[i][1] > maxY) maxY = points[i][1];
      }
      ctx.save();
      polygon(points);
      ctx.clip();
      ctx.fillStyle = color;
      ctx.fillRect(minX - 1, minY - 1, maxX - minX + 2, maxY - minY + 2);
      ctx.restore();
    }

    // --- Window line-work masks -------------------------------------------
    // The frame bands, muntins and glass-shine strokes are the NON-dark
    // pixels of the house art inside each window region. Extracting them
    // into a mask and tinting it with the wall's night color reproduces the
    // art's exact line geometry, weight and hand-drawn wobble on top of the
    // warm pane fills. Falls back to simple bars if pixels are unreadable
    // (e.g. a cross-origin image tainting the canvas).
    var WINDOW_REGIONS = {
      front: [[208, 152, 271, 213], [207, 283, 264, 337]],
      right: [[452, 253, 519, 338], [553, 258, 582, 308], [599, 258, 602, 308]],
      dormer: [[511, 162, 546, 198]]
    };
    var lineMasks = null;
    var maskTintCache = {};

    function buildWindowLineMasks() {
      if (lineMasks !== null) return lineMasks;
      try {
        var probe = document.createElement('canvas');
        probe.width = HOUSE_W;
        probe.height = HOUSE_H;
        var pctx = probe.getContext('2d');
        pctx.drawImage(house, 0, 0, HOUSE_W, HOUSE_H);
        var masks = {};
        Object.keys(WINDOW_REGIONS).forEach(function (wall) {
          var m = document.createElement('canvas');
          m.width = HOUSE_W;
          m.height = HOUSE_H;
          var mctx = m.getContext('2d');
          var out = mctx.createImageData(HOUSE_W, HOUSE_H);
          WINDOW_REGIONS[wall].forEach(function (r) {
            var w = r[2] - r[0];
            var h = r[3] - r[1];
            var img = pctx.getImageData(r[0], r[1], w, h).data;
            for (var yy = 0; yy < h; yy++) {
              for (var xx = 0; xx < w; xx++) {
                var i = (yy * w + xx) * 4;
                if (img[i + 3] < 128 || img[i] + img[i + 1] + img[i + 2] > 420) {
                  var o = ((r[1] + yy) * HOUSE_W + r[0] + xx) * 4;
                  out.data[o] = 255;
                  out.data[o + 1] = 255;
                  out.data[o + 2] = 255;
                  out.data[o + 3] = 255;
                }
              }
            }
          });
          mctx.putImageData(out, 0, 0);
          masks[wall] = m;
        });
        lineMasks = masks;
      } catch (err) {
        lineMasks = false;
      }
      return lineMasks;
    }

    function tintedLineMask(wall, tint) {
      var key = wall + tint;
      if (!maskTintCache[key]) {
        var m = lineMasks[wall];
        var c = document.createElement('canvas');
        c.width = m.width;
        c.height = m.height;
        var cctx = c.getContext('2d');
        cctx.drawImage(m, 0, 0);
        cctx.globalCompositeOperation = 'source-in';
        cctx.fillStyle = tint;
        cctx.fillRect(0, 0, c.width, c.height);
        maskTintCache[key] = c;
      }
      return maskTintCache[key];
    }

    function signFaceColor(front) {
      if (!state.night) return front ? paper : '#d9d9d9';
      if (period === 'dusk') return front ? '#c0ad94' : '#a99c91';
      return front ? '#94958f' : '#777b7d';
    }

    function path(points, width, color) {
      ctx.beginPath();
      points.forEach(function (p, i) {
        if (i) ctx.lineTo(p[0], p[1]);
        else ctx.moveTo(p[0], p[1]);
      });
      ctx.strokeStyle = color === undefined ? INK : color;
      ctx.lineWidth = width === undefined ? 2 : width;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.stroke();
    }

    function ellipse(x, y, rx, ry, color) {
      ctx.beginPath();
      ctx.ellipse(x, y, rx, ry, 0, 0, Math.PI * 2);
      ctx.fillStyle = color === undefined ? INK : color;
      ctx.fill();
    }

    var HOUSE_W = 774;
    var HOUSE_H = 473;

    function paintHouse(target) {
      if (!house || !house.naturalWidth) return;
      target.drawImage(house, 0, 0, HOUSE_W, HOUSE_H);
    }

    function cutMove(points, px, py, angle) {
      ctx.save();
      polygon(points);
      ctx.fillStyle = paper;
      ctx.fill();
      if (points === signShape) path([[586, 365], [577, 417]], 4);
      ctx.translate(px, py);
      ctx.rotate(angle);
      ctx.translate(-px, -py);
      polygon(points);
      ctx.clip();
      if (points === signShape) {
        ctx.fillStyle = paper;
        ctx.fill();
      }
      paintHouse(ctx);
      ctx.restore();
    }

    function breeze(t) {
      var g = t - state.gust;
      var base =
        g >= 0 && g < 5.6
          ? Math.sin((Math.PI * g) / 5.6) * Math.sin(g * 3.6) * 0.024
          : Math.sin(t * 0.6) * 0.0028;
      return base * HutSeasons.config[season].wind;
    }

    function drawSignBackground() {
      ctx.save();
      polygon([[545, 352], [640, 371], [652, 407], [622, 429], [548, 409]]);
      ctx.clip();
      ctx.fillStyle = paper;
      ctx.fillRect(540, 348, 118, 88);
      polygon([[526, 333], [640, 333], [640, 365], [604, 365], [526, 378]]);
      ctx.fillStyle = state.night ? (period === 'dusk' ? '#ad9f8b' : '#707975') : paper;
      ctx.fill();
      ctx.save();
      polygon([[526, 333], [640, 333], [640, 365], [604, 365], [526, 378]]);
      ctx.clip();
      path([[530, 351], [570, 343], [637, 339]], 1.5);
      path([[526, 366.7], [548, 363.4], [580, 358.6], [620, 352.6], [640, 349.6]], 3.2);
      path([[549, 369.5], [558, 368.4]], 0.9);
      path([[571, 365.8], [578, 365]], 0.8);
      [
        [[551, 358], [558, 357]],
        [[560, 369], [568, 367]],
        [[592, 358], [606, 356]],
        [[615, 365], [624, 364]],
        [[600, 350], [604, 349]]
      ].forEach(function (line) {
        path(line, 0.8);
      });
      path([[635, 334], [634, 369]], 2.3);
      path([[639, 333], [638, 368]], 1.4);
      ctx.restore();
      path([[526, 377.6], [548, 374.1], [578, 369.3], [604, 365.1], [640, 365.5], [660, 368]], 3.5);
      polygon([[584, 356], [590, 356], [580, 421], [574, 421]]);
      ctx.fillStyle = INK;
      ctx.fill();
      path([[587, 358], [577, 419]], 1, state.night ? '#8d8e86' : paper);
      ctx.restore();
      ctx.save();
      polygon([[536, 432], [548, 414], [575, 407], [596, 413], [603, 414], [600, 439], [545, 451], [536, 441]]);
      ctx.clip();
      ctx.fillStyle = paper;
      ctx.fill();
      if (state.night) fillClipped(teatimeFill, signFaceColor(true));
      paintHouse(ctx);
      ctx.restore();
    }

    function rotateSignAroundPost(angle) {
      var facingAngle = Math.atan2(Math.sin(angle), Math.cos(angle));
      if (Math.abs(facingAngle) < 0.1) return;
      ctx.save();
      drawSignBackground();
      path([[586, 365], [577, 417]], 4);
      var slope = -9 / 52;
      var norm = Math.hypot(slope, 1);
      var vx = slope / norm;
      var vy = 1 / norm;
      var ux = vy;
      var uy = -vx;
      var c = Math.cos(angle);
      var depth = Math.sin(angle) * 0.18;
      ctx.translate(586 + slope * 15, 380);
      ctx.transform(
        vx * vx + c * ux * ux + depth * vx * ux,
        vx * vy + c * ux * uy + depth * vy * ux,
        vx * vy + c * ux * uy + depth * vx * uy,
        vy * vy + c * uy * uy + depth * vy * uy,
        0,
        0
      );
      ctx.translate(-(586 + slope * 15), -380);
      fillClipped(signFill, signFaceColor(c >= 0));
      ctx.save();
      polygon(signShape);
      ctx.clip();
      if (c >= 0) {
        // Front face: house art (fill, text, woodgrain) stays clipped inside the shape.
        paintHouse(ctx);
      } else {
        path([[558, 368], [627, 382]], 1.3);
        path([[558, 396], [619, 411]], 1.3);
        path([[562, 383], [573, 385]], 1);
        path([[614, 391], [633, 395]], 1);
        ellipse(581, 383, 1.5, 1.5);
        ellipse(578, 398, 1.5, 1.5);
      }
      ctx.restore();
      // Outline for every rotation angle: build the path under the sign transform,
      // then stroke it at constant scene width so neither the clip nor the edge-on
      // squeeze can thin it away. Fill/text/woodgrain above remain clipped inside.
      polygon(signShape);
      ctx.strokeStyle = INK;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      if (sceneCTM && ctx.setTransform) {
        ctx.save();
        ctx.setTransform(sceneCTM);
        ctx.lineWidth = 2.5;
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.lineWidth = 2.5;
        ctx.stroke();
      }
      ctx.restore();
    }

    function drawSmoke(t) {
      var extra = clamp(1 - (t - state.smoke) / 4);
      for (var i = 0; i < 7; i++) {
        var p = (t * 0.15 + i / 7) % 1;
        var fade = Math.sin(Math.PI * p) * (1 - p);
        var x = 365 + Math.sin(p * 7 + t * 0.28) * 12 + p * (32 + extra * 45);
        var y = 4 - p * 122;
        var s = 6 + p * 21;
        ctx.save();
        ctx.globalAlpha = fade * (0.24 + extra * 0.12) * HutSeasons.config[season].smoke;
        ctx.strokeStyle = state.night ? '#b9c1ce' : INK;
        ctx.lineWidth = 1.25;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(x - s * 0.45, y + s * 0.25);
        ctx.bezierCurveTo(x - s * 1.1, y - s * 0.18, x - s * 0.6, y - s * 0.65, x + s * 0.03, y - s * 0.63);
        ctx.bezierCurveTo(x + s * 0.55, y - s * 1.05, x + s * 1.02, y - s * 0.46, x + s * 0.64, y - s * 0.04);
        ctx.bezierCurveTo(x + s * 1.02, y + s * 0.35, x + s * 0.36, y + s * 0.69, x - s * 0.14, y + s * 0.48);
        ctx.stroke();
        ctx.globalAlpha *= 0.35;
        ctx.beginPath();
        ctx.moveTo(x - s * 0.42, y + s * 0.43);
        ctx.bezierCurveTo(x + s * 0.2, y + s * 0.9, x + s * 1.2, y + s * 0.5, x + s * 0.83, y);
        ctx.stroke();
        ctx.restore();
      }
    }

    function drawWind(t) {
      var a = t - state.gust;
      if (a < 0 || a > 5.6) return;
      for (var i = 0; i < 3; i++) {
        var p = (a * 0.33 + i * 0.28) % 1;
        var x = -55 + p * 930;
        var y = 220 + i * 93 + Math.sin(p * 7 + i) * 18;
        ctx.save();
        ctx.globalAlpha = Math.sin(p * Math.PI) * 0.25 * Math.sin((a / 5.6) * Math.PI);
        ctx.strokeStyle = state.night ? '#b9c1ce' : INK;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(x - 38, y);
        ctx.bezierCurveTo(x - 12, y - 9, x + 5, y + 3, x + 28, y - 5);
        ctx.stroke();
        ctx.translate(x + 45, y + 1);
        ctx.rotate(Math.sin(a * 2 + i) * 0.7);
        ctx.beginPath();
        ctx.moveTo(-5, 0);
        ctx.quadraticCurveTo(0, -5, 7, 0);
        ctx.quadraticCurveTo(0, 4, -5, 0);
        ctx.stroke();
        ctx.restore();
      }
    }

    function nightSurfaces() {
      if (!state.night) return;
      ctx.fillStyle = period === 'dusk' ? '#b9a997' : '#858782';
      polygon([[104, 244], [240, 68], [377, 244], [384, 414], [279, 407], [184, 419], [104, 407]]);
      ctx.fill();
      ctx.fillStyle = period === 'dusk' ? '#ad9f8b' : '#707975';
      polygon([[382, 244], [650, 245], [638, 365], [604, 365], [431, 393], [383, 413]]);
      ctx.fill();
      ctx.fillStyle = period === 'dusk' ? '#c0ad94' : '#94958f';
      polygon([[493, 159], [525, 135], [553, 161], [553, 208], [494, 204]]);
      ctx.fill();
      ctx.fillStyle = period === 'dusk' ? '#a99c91' : '#727b7d';
      polygon([[337, 16], [398, 19], [398, 101], [337, 80]]);
      ctx.fill();
      var face = signFaceColor(true);
      fillClipped(signFill, face);
      fillClipped(bigChangeFill, face);
      fillClipped(teatimeFill, face);
    }

    function drawWindows() {
      if (!state.night) return;
      ctx.save();
      if (period === 'dusk') ctx.globalAlpha = 0.6;
      [
        [239, 184, 75],
        [235, 310, 65],
        [483, 300, 75],
        [530, 179, 40],
        [566, 281, 40, 0.5]
      ].forEach(function (item) {
        var strength = item[3] === undefined ? 1 : item[3];
        var glow = ctx.createRadialGradient(item[0], item[1], 4, item[0], item[1], item[2]);
        glow.addColorStop(0, 'rgba(255,197,98,' + 0.2 * strength + ')');
        glow.addColorStop(1, 'rgba(255,197,98,0)');
        ctx.fillStyle = glow;
        ctx.fillRect(item[0] - item[2], item[1] - item[2], item[2] * 2, item[2] * 2);
      });
      // Pane fills cover the whole glass of each cell: outer edges sit on the
      // measured glass boundary, inner edges run PAST the muntin bars, which
      // are redrawn on top afterwards at their original geometry. That keeps
      // the glass fully lit (no dark seam) without thinning the line work.
      [
        // 2F left window
        [[209.2, 152.2], [240.5, 152.2], [240.5, 183], [209.2, 183]],
        [[239.5, 152.2], [269.8, 152.2], [269.8, 183], [239.5, 183]],
        [[209.2, 182], [240.5, 182], [240.5, 212.8], [209.2, 212.8]],
        [[239.5, 182], [269.8, 182], [269.8, 212.8], [239.5, 212.8]],
        // front door window
        [[210.2, 285.2], [236.5, 285.2], [236.5, 310.2], [210.2, 310.2]],
        [[235.5, 285.2], [262.8, 285.2], [262.8, 310.2], [235.5, 310.2]],
        [[210.2, 309.3], [236.5, 309.3], [236.5, 334.8], [210.2, 334.8]],
        [[235.5, 309.3], [262.8, 309.3], [262.8, 334.8], [235.5, 334.8]],
        // big 1F right-wall window (slanted with the wall). The dark band
        // across the window top is the roof's cast shadow, not glass, so the
        // upper panes start below it and it stays dark at night.
        [[452.2, 266.3], [487.6, 263.7], [487.6, 298.2], [452.2, 300.2]],
        [[486.4, 264.1], [517.8, 261.8], [517.8, 297], [486.4, 298.2]],
        [[452.2, 298.8], [487.6, 297], [487.6, 333.4], [452.2, 333.8]],
        [[486.4, 297], [517.8, 295.2], [517.8, 330.8], [486.4, 332.6]],
        // attic (dormer) window
        [[512, 163], [530.4, 163], [530.4, 181], [512, 181]],
        [[529.6, 164], [545, 164], [545, 181], [529.6, 181]],
        [[512, 180], [530.4, 180], [530.4, 197], [512, 197]],
        [[529.6, 180], [545, 180], [545, 197], [529.6, 197]]
      ].forEach(function (pts) {
        var y = pts[0][1];
        var lightFill = ctx.createLinearGradient(0, y, 0, y + 36);
        lightFill.addColorStop(0, '#ffdba1');
        lightFill.addColorStop(1, '#d9a64e');
        polygon(pts);
        ctx.fillStyle = lightFill;
        ctx.fill();
      });
      // Back-room window behind the BIG CHANGE sign (right of the big 1F
      // window): warm but more subdued than the other windows. Only the dark
      // glass cells are painted, so the frame, mullion and cross-bar keep
      // reading as drawn, and the fills stop above the sign's inked top edge
      // so the foreground board still occludes the sill.
      [
        [[554.2, 258], [578.5, 258], [578.5, 290.8], [554.2, 290.8]],
        [[554.2, 289.6], [578.5, 289.2], [578.5, 303.3], [554.2, 300.8]],
        [[579.5, 258], [600.8, 258], [600.8, 297.5], [592, 302.8], [579.5, 303.8]]
      ].forEach(function (pts) {
        var y = pts[0][1];
        var dimFill = ctx.createLinearGradient(0, y, 0, y + 46);
        dimFill.addColorStop(0, '#e0ba82');
        dimFill.addColorStop(1, '#a97f3e');
        polygon(pts);
        ctx.fillStyle = dimFill;
        ctx.fill();
      });
      ctx.restore();
      // Put the window line-work back on top of the fills, in the same tint
      // nightSurfaces gives the wall that shows through the paper there, so
      // frames and muntins keep exactly the geometry, weight and hand-drawn
      // wobble they have in the day render.
      var frontTint = period === 'dusk' ? '#b9a997' : '#858782';
      var rightTint = period === 'dusk' ? '#ad9f8b' : '#707975';
      var dormerTint = period === 'dusk' ? '#c0ad94' : '#94958f';
      var masks = buildWindowLineMasks();
      canvas.dataset.lineMask = masks ? '1' : '0';
      if (masks) {
        ctx.drawImage(tintedLineMask('front', frontTint), 0, 0, HOUSE_W, HOUSE_H);
        ctx.drawImage(tintedLineMask('right', rightTint), 0, 0, HOUSE_W, HOUSE_H);
        ctx.drawImage(tintedLineMask('dormer', dormerTint), 0, 0, HOUSE_W, HOUSE_H);
      } else {
        // Fallback when the art's pixels cannot be read: plain bars at the
        // measured muntin geometry.
        [
          [frontTint, [[239, 153], [241, 153], [241, 212], [239, 212]]],
          [frontTint, [[210, 181], [269, 181], [269, 184], [210, 184]]],
          [frontTint, [[235, 286], [237, 286], [237, 334], [235, 334]]],
          [frontTint, [[211, 308], [262, 308], [262, 311.5], [211, 311.5]]],
          [rightTint, [[486, 264], [488, 264], [488, 332.3], [486, 332.9]]],
          [rightTint, [[453, 298.1], [517, 295.3], [517, 297.7], [453, 300.9]]],
          [dormerTint, [[529, 163], [531, 163], [531, 197], [529, 197]]],
          [dormerTint, [[512, 180], [545, 180], [545, 181], [512, 181]]],
          [rightTint, [[555, 289], [577, 288.7], [577, 291.2], [555, 292]]]
        ].forEach(function (bar) {
          polygon(bar[1]);
          ctx.fillStyle = bar[0];
          ctx.fill();
        });
      }
    }

    function withoutTrees() {
      if (bareHouse) return bareHouse;
      var srcW = house && house.naturalWidth ? house.naturalWidth : HOUSE_W;
      var srcH = house && house.naturalHeight ? house.naturalHeight : HOUSE_H;
      var sx = srcW / HOUSE_W;
      var sy = srcH / HOUSE_H;
      bareHouse = document.createElement('canvas');
      bareHouse.width = srcW;
      bareHouse.height = srcH;
      var b = bareHouse.getContext('2d');
      b.imageSmoothingEnabled = true;
      b.imageSmoothingQuality = 'high';
      b.drawImage(house, 0, 0, srcW, srcH);
      b.globalCompositeOperation = 'destination-out';
      [leftTree, rightTree, littleTree].forEach(function (pts) {
        b.beginPath();
        pts.forEach(function (p, i) {
          var x = p[0] * sx;
          var y = p[1] * sy;
          if (i) b.lineTo(x, y);
          else b.moveTo(x, y);
        });
        b.closePath();
        b.fill();
        b.lineWidth = 4 * Math.max(sx, sy);
        b.stroke();
      });
      return bareHouse;
    }

    function paintSceneHouse(newTrees) {
      if (newTrees) ctx.drawImage(withoutTrees(), 0, 0, HOUSE_W, HOUSE_H);
      else paintHouse(ctx);
    }

    // --- Season dial: small woodcut fan on the wall left of the front door. ---
    var DIAL_CX = 153;
    var DIAL_CY = 330;
    var DIAL_R = 30;
    var DIAL_OPEN = Math.PI / 3;
    var DIAL_TINT = { spring: '#f2e9e4', summer: '#eddbb2', autumn: '#eed4ba', winter: '#d5dee3' };

    function fanPath(inset) {
      var up = -Math.PI / 2;
      ctx.beginPath();
      ctx.moveTo(DIAL_CX, DIAL_CY);
      ctx.arc(DIAL_CX, DIAL_CY, DIAL_R - inset, up - DIAL_OPEN, up + DIAL_OPEN);
      ctx.closePath();
    }

    function dialInk(width, color) {
      ctx.strokeStyle = color === undefined ? INK : color;
      ctx.lineWidth = width;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.stroke();
    }

    // Dial hero motifs, drawn like the house: bold ink outlines with a
    // dry-brush stroke inside and a subdued color fill, sized to stay
    // readable at the dial's real on-page size.
    function heroPetal(x, y, s, rot, alpha) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(x, y);
      ctx.rotate(rot);
      ctx.scale(s, s);
      // slim sakura petal: long taper to the base, only a shallow nick at
      // the outer edge so it never reads as a heart
      ctx.beginPath();
      ctx.moveTo(0, -0.6);
      ctx.quadraticCurveTo(-0.1, -0.72, -0.2, -0.66);
      ctx.quadraticCurveTo(-0.36, -0.5, -0.32, -0.12);
      ctx.quadraticCurveTo(-0.26, 0.35, 0, 0.75);
      ctx.quadraticCurveTo(0.26, 0.35, 0.32, -0.12);
      ctx.quadraticCurveTo(0.36, -0.5, 0.2, -0.66);
      ctx.quadraticCurveTo(0.1, -0.72, 0, -0.6);
      ctx.closePath();
      ctx.fillStyle = '#eebac3';
      ctx.fill();
      dialInk(1.35 / s);
      ctx.beginPath();
      ctx.moveTo(-0.14, 0.3);
      ctx.quadraticCurveTo(0, 0.02, 0.08, -0.3);
      ctx.globalAlpha = alpha * 0.7;
      dialInk(0.7 / s);
      ctx.restore();
    }

    function heroLeaf(x, y, s, rot, alpha) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(x, y);
      ctx.rotate(rot);
      ctx.scale(s, s);
      ctx.beginPath();
      ctx.moveTo(0, -0.62);
      ctx.quadraticCurveTo(0.52, -0.3, 0.44, 0.16);
      ctx.quadraticCurveTo(0.34, 0.54, 0, 0.68);
      ctx.quadraticCurveTo(-0.34, 0.54, -0.44, 0.16);
      ctx.quadraticCurveTo(-0.52, -0.3, 0, -0.62);
      ctx.closePath();
      ctx.fillStyle = '#abc79a';
      ctx.fill();
      dialInk(1.35 / s);
      ctx.beginPath();
      ctx.moveTo(0, 0.68);
      ctx.lineTo(0.06, 0.92);
      dialInk(1.1 / s);
      ctx.beginPath();
      ctx.moveTo(0, -0.44);
      ctx.lineTo(0, 0.56);
      dialInk(0.8 / s);
      [[-0.04, -0.12, -0.28, 0.02], [0.04, -0.12, 0.28, 0.02], [-0.04, 0.2, -0.26, 0.36], [0.04, 0.2, 0.26, 0.36]].forEach(
        function (v) {
          ctx.beginPath();
          ctx.moveTo(v[0], v[1]);
          ctx.lineTo(v[2], v[3]);
          dialInk(0.5 / s);
        }
      );
      ctx.restore();
    }

    function heroMaple(x, y, s, rot, alpha) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(x, y);
      ctx.rotate(rot);
      var k = s / 6.6;
      ctx.scale(k, k);
      var P = [
        [0, -6.6], [0.9, -3.9], [3.6, -5.2], [2.9, -2.4], [6.2, -1.6], [3.5, 0.5], [4.3, 3.4], [1.5, 2.1],
        [0.5, 3.4], [0.7, 5.6], [-0.7, 5.6], [-0.5, 3.4], [-1.5, 2.1], [-4.3, 3.4], [-3.5, 0.5], [-6.2, -1.6],
        [-2.9, -2.4], [-3.6, -5.2], [-0.9, -3.9]
      ];
      ctx.beginPath();
      P.forEach(function (p, idx) {
        if (idx) ctx.lineTo(p[0], p[1]);
        else ctx.moveTo(p[0], p[1]);
      });
      ctx.closePath();
      ctx.fillStyle = '#cd7047';
      ctx.fill();
      dialInk(1.35 / k);
      [[0, 2, 0, -5], [0, 1.4, -4.4, -1], [0, 1.4, 4.4, -1]].forEach(function (v) {
        ctx.beginPath();
        ctx.moveTo(v[0], v[1]);
        ctx.lineTo(v[2], v[3]);
        dialInk(0.55 / k);
      });
      ctx.restore();
    }

    function heroSnowman(x, y, s, alpha) {
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(x, y);
      var k = s / 7;
      ctx.scale(k, k);
      ctx.beginPath();
      ctx.arc(0, 3.2, 3.5, 0, Math.PI * 2);
      ctx.fillStyle = '#f4f3ef';
      ctx.fill();
      dialInk(1.3 / k);
      ctx.beginPath();
      ctx.arc(0, -1.9, 2.5, 0, Math.PI * 2);
      ctx.fillStyle = '#f4f3ef';
      ctx.fill();
      dialInk(1.3 / k);
      // top hat
      ctx.beginPath();
      ctx.moveTo(-2.6, -3.8);
      ctx.lineTo(2.6, -3.8);
      dialInk(1.1 / k);
      ctx.fillStyle = INK;
      ctx.fillRect(-1.6, -6.8, 3.2, 3);
      // eyes and buttons
      ctx.beginPath();
      ctx.arc(-0.8, -2.3, 0.34, 0, Math.PI * 2);
      ctx.arc(0.8, -2.3, 0.34, 0, Math.PI * 2);
      ctx.fill();
      ctx.beginPath();
      ctx.arc(0, 1.9, 0.36, 0, Math.PI * 2);
      ctx.fill();
      ctx.beginPath();
      ctx.arc(0, 3.6, 0.36, 0, Math.PI * 2);
      ctx.fill();
      // stick arms
      ctx.beginPath();
      ctx.moveTo(-3.3, 1.7);
      ctx.lineTo(-5.4, 0.2);
      dialInk(0.8 / k);
      ctx.beginPath();
      ctx.moveTo(3.3, 1.7);
      ctx.lineTo(5.4, 0.2);
      dialInk(0.8 / k);
      ctx.restore();
    }

    function dialSector(i) {
      var name = SEASONS[i];
      // paper-toned ground with a pale seasonal tint
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.arc(0, 0, DIAL_R, -Math.PI / 2 - Math.PI / 4, -Math.PI / 2 + Math.PI / 4);
      ctx.closePath();
      ctx.fillStyle = DIAL_TINT[name];
      ctx.fill();
      // wood/paper grain speckle
      ctx.save();
      ctx.strokeStyle = INK;
      ctx.lineCap = 'round';
      ctx.lineWidth = 0.45;
      ctx.globalAlpha = 0.16;
      var seed = 97 + i * 131;
      for (var g = 0; g < 10; g++) {
        seed = (seed * 16807) % 2147483647;
        var ga = -Math.PI / 2 + ((seed % 1000) / 1000 - 0.5) * 1.3;
        seed = (seed * 16807) % 2147483647;
        var gr = 7 + ((seed % 1000) / 1000) * 19;
        var gx = Math.cos(ga) * gr;
        var gy = Math.sin(ga) * gr;
        ctx.beginPath();
        ctx.moveTo(gx - 1.1, gy);
        ctx.lineTo(gx + 0.7, gy - 0.2);
        ctx.stroke();
      }
      ctx.restore();
      // thick hand-carved divider on the sector's boundary
      ctx.save();
      ctx.rotate(Math.PI / 4);
      path([[0, -3.4], [0, -(DIAL_R - 0.5)]], 1.9);
      ctx.restore();
      // hero motif
      if (i === 0) {
        heroPetal(-2.9, -22.8, 5.8, -0.85, 1);
        heroPetal(3.4, -20.8, 4.6, 0.95, 1);
      } else if (i === 1) {
        heroLeaf(0, -22.2, 6.6, -0.3, 1);
      } else if (i === 2) {
        heroMaple(0, -22.4, 5.3, 0.1, 1);
      } else {
        heroSnowman(0, -22.6, 5, 1);
      }
      // carved season name, kept inside the sector's safe chord in every
      // rotation state (the bound is angular, so it holds mid-turn too)
      ctx.save();
      ctx.fillStyle = INK;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var label = SEASON_EN[name];
      var fs = 4.7;
      ctx.font = '800 ' + fs + 'px Inter, "Helvetica Neue", Arial, sans-serif';
      var lw = ctx.measureText(label).width;
      if (lw > 16.2) {
        fs = (fs * 16.2) / lw;
        ctx.font = '800 ' + fs + 'px Inter, "Helvetica Neue", Arial, sans-serif';
      }
      ctx.fillText(label, 0, -14.2);
      ctx.globalAlpha = 0.35;
      ctx.fillText(label, 0.3, -14);
      ctx.restore();
    }

    function drawNeighborWedge(side, name, alpha) {
      var cx = DIAL_CX;
      var cy = DIAL_CY;
      var up = -Math.PI / 2;
      var a0 = up + side * (Math.PI / 4);
      var a1 = up + side * DIAL_OPEN;
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, DIAL_R - 0.7, Math.min(a0, a1), Math.max(a0, a1));
      ctx.closePath();
      ctx.fillStyle = DIAL_TINT[name];
      ctx.fill();
      // keep the neighbor's motif inside its sliver: anything past the
      // divider is clipped away instead of spilling into the open sector
      ctx.save();
      ctx.clip();
      var mid = up + side * ((DIAL_OPEN + Math.PI / 4) / 2);
      var mx = cx + Math.cos(mid) * 20.5;
      var my = cy + Math.sin(mid) * 20.5;
      if (name === 'spring') heroPetal(mx, my, 3.6, side * 0.9, alpha);
      else if (name === 'summer') heroLeaf(mx, my, 3.6, side * 0.4, alpha);
      else if (name === 'autumn') heroMaple(mx, my, 3.2, side * 0.3, alpha);
      else heroSnowman(mx, my, 3, alpha);
      ctx.restore();
      ctx.strokeStyle = INK;
      ctx.lineCap = 'round';
      ctx.lineWidth = 1.9;
      ctx.beginPath();
      ctx.moveTo(cx + Math.cos(a0) * 3.4, cy + Math.sin(a0) * 3.4);
      ctx.lineTo(cx + Math.cos(a0) * (DIAL_R - 0.5), cy + Math.sin(a0) * (DIAL_R - 0.5));
      ctx.stroke();
      ctx.restore();
    }

    function drawDialArrow(nudge) {
      var cx = DIAL_CX;
      ctx.save();
      // the idle nudge moves the whole arrow down and back as one piece —
      // a pure translation, so the woodcut shape never distorts
      if (nudge) ctx.translate(0, nudge);
      ctx.fillStyle = INK;
      ctx.strokeStyle = INK;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      // curled hanging hook
      ctx.beginPath();
      ctx.arc(cx + 1.1, 283.4, 2.2, -2.6, 1.35);
      ctx.lineWidth = 1.7;
      ctx.stroke();
      // elongated downward arrow, tip overlapping the disc face
      ctx.beginPath();
      ctx.moveTo(cx - 1.3, 285.2);
      ctx.lineTo(cx - 1.3, 295.6);
      ctx.lineTo(cx - 3.6, 295.1);
      ctx.lineTo(cx, 302.3);
      ctx.lineTo(cx + 3.6, 295.1);
      ctx.lineTo(cx + 1.3, 295.6);
      ctx.lineTo(cx + 1.3, 285.2);
      ctx.closePath();
      ctx.fill();
      ctx.lineWidth = 0.9;
      ctx.stroke();
      // thin paper relief line inside
      ctx.strokeStyle = !state.night ? paper : period === 'dusk' ? '#d8c4a6' : '#b8bab2';
      ctx.globalAlpha = 0.85;
      ctx.lineWidth = 0.55;
      ctx.beginPath();
      ctx.moveTo(cx, 286.6);
      ctx.lineTo(cx, 299.8);
      ctx.stroke();
      ctx.restore();
    }

    function drawSeasonDial(t) {
      var cx = DIAL_CX;
      var cy = DIAL_CY;
      var up = -Math.PI / 2;
      var target = -(dialTurns || 0) * (Math.PI / 2);
      if (state.dialAngle === null) state.dialAngle = target;
      if (reduced.matches) {
        state.dialAngle = target;
      } else {
        var dt = Math.min(Math.max(t - state.dialLastT, 0), 0.05);
        var diff = target - state.dialAngle;
        if (diff) {
          state.dialAngle += diff * Math.min(1, dt * 9);
          if (Math.abs(target - state.dialAngle) < 0.0008) state.dialAngle = target;
        }
      }
      state.dialLastT = t;
      var animating = Math.abs(target - state.dialAngle) > 0.01;
      // Idle affordance: every 6-8 s the arrow alone dips ~2.5 px and eases
      // back (one round trip). The disc and frame stay fully static while
      // idle, the nudge is suppressed during a season rotation, and the
      // timer restarts after each click.
      var nudge = 0;
      if (!reduced.matches && !animating) {
        if (t >= state.nextNudge) {
          state.nudgeStart = t;
          state.nextNudge = t + 6 + Math.random() * 2;
        }
        var np = (t - state.nudgeStart) / 0.7;
        if (np >= 0 && np < 1) {
          nudge = Math.sin(Math.PI * smooth(np)) * 2.6;
        }
      }
      var selIdx = (((dialTurns || 0) % 4) + 4) % 4;
      var wedgeAlpha = reduced.matches ? 1 : Math.max(0, 1 - Math.abs(target - state.dialAngle) / 0.3);

      // rotating disc, visible only through the fan opening
      ctx.save();
      fanPath(0.8);
      ctx.clip();
      ctx.translate(cx, cy);
      ctx.rotate(state.dialAngle);
      for (var i = 0; i < 4; i++) {
        ctx.save();
        ctx.rotate((i * Math.PI) / 2);
        dialSector(i);
        ctx.restore();
      }
      ctx.restore();

      // fixed tinted wedges previewing the neighbouring seasons (they fade
      // out while the disc is turning and return once it settles)
      if (wedgeAlpha > 0.03) {
        drawNeighborWedge(-1, SEASONS[(selIdx + 3) % 4], wedgeAlpha);
        drawNeighborWedge(1, SEASONS[(selIdx + 1) % 4], wedgeAlpha);
      }

      // radiating carve ticks above the pivot
      ctx.save();
      ctx.strokeStyle = INK;
      ctx.lineCap = 'round';
      ctx.lineWidth = 0.6;
      ctx.globalAlpha = 0.7;
      for (var rr = -3; rr <= 3; rr++) {
        var ra = up + rr * 0.17;
        var r1 = 8.6 + (rr % 2 === 0 ? 1 : 0);
        ctx.beginPath();
        ctx.moveTo(cx + Math.cos(ra) * 5.6, cy + Math.sin(ra) * 5.6);
        ctx.lineTo(cx + Math.cos(ra) * r1, cy + Math.sin(ra) * r1);
        ctx.stroke();
      }
      ctx.restore();

      // night / dusk dimming of the whole face
      if (state.night) {
        fanPath(0);
        ctx.fillStyle = period === 'dusk' ? 'rgba(140,110,75,0.25)' : 'rgba(35,42,52,0.38)';
        ctx.fill();
      }

      // stitched inner border
      ctx.save();
      ctx.strokeStyle = INK;
      ctx.lineWidth = 0.65;
      ctx.setLineDash([1.5, 1.3]);
      ctx.beginPath();
      ctx.arc(cx, cy, DIAL_R - 2.7, up - DIAL_OPEN + 0.1, up + DIAL_OPEN - 0.1);
      ctx.stroke();
      [-1, 1].forEach(function (sd) {
        var aa = up + sd * (DIAL_OPEN - 0.09);
        ctx.beginPath();
        ctx.moveTo(cx + Math.cos(aa) * 6, cy + Math.sin(aa) * 6);
        ctx.lineTo(cx + Math.cos(aa) * (DIAL_R - 2.7), cy + Math.sin(aa) * (DIAL_R - 2.7));
        ctx.stroke();
      });
      ctx.restore();

      // thick hand-carved outer border (double pass for an uneven edge)
      ctx.strokeStyle = INK;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      fanPath(0);
      ctx.lineWidth = 3;
      ctx.stroke();
      ctx.save();
      ctx.globalAlpha = 0.85;
      ctx.beginPath();
      ctx.arc(cx + 0.35, cy - 0.3, DIAL_R + 0.8, up - DIAL_OPEN + 0.06, up + DIAL_OPEN - 0.03);
      ctx.lineWidth = 1.2;
      ctx.stroke();
      ctx.restore();

      // pivot bolt with washer ring
      ctx.beginPath();
      ctx.arc(cx, cy + 0.6, 3.4, 0, Math.PI * 2);
      ctx.fillStyle = !state.night ? paper : period === 'dusk' ? '#c9b298' : '#9a9b95';
      ctx.fill();
      ctx.strokeStyle = INK;
      ctx.lineWidth = 1.5;
      ctx.stroke();
      ellipse(cx, cy + 0.6, 1.2, 1.2, INK);

      // fixed hanging hook-arrow, drawn last so its tip sits on the disc
      drawDialArrow(nudge);

      canvas.dataset.dialAngle = state.dialAngle.toFixed(4);
      canvas.dataset.dialNudging = String(nudge !== 0);
    }

    function draw(t) {
      if (!houseReady || !effectsReady || !canvas.clientWidth) return;
      var dpr = window.devicePixelRatio || 1;
      if (dpr > 3) dpr = 3;
      var targetW = Math.max(1, Math.round(canvas.clientWidth * dpr));
      var targetH = Math.max(1, Math.round((canvas.clientHeight || (canvas.clientWidth * H) / W) * dpr));
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      if (canvas.width !== targetW || canvas.height !== targetH) {
        canvas.width = targetW;
        canvas.height = targetH;
      }
      ctx.setTransform(canvas.width / W, 0, 0, canvas.height / H, 0, 0);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = paper;
      ctx.fillRect(0, 0, W, H);
      ctx.save();
      ctx.translate(OX, OY);
      sceneCTM = ctx.getTransform ? ctx.getTransform() : null;
      drawSmoke(t);
      var newTrees = season === 'spring';
      var wind = breeze(t);
      effects.draw(ctx, {
        season: season,
        night: period === 'night',
        time: t,
        layer: 'back',
        reduced: reduced.matches,
        gust: Math.abs(wind) * 25
      });
      ctx.fillStyle = paper;
      polygon([
        [79, 244],
        [238, 54],
        [549, 109],
        [665, 234],
        [670, 245],
        [650, 249],
        [638, 365],
        [604, 365],
        [383, 413],
        [279, 407],
        [184, 419],
        [104, 407],
        [104, 249]
      ]);
      ctx.fill();
      polygon([[329, 12], [357, 0], [406, 12], [399, 22], [399, 103], [336, 87], [335, 23]]);
      ctx.fill();
      nightSurfaces();
      paintSceneHouse(newTrees);
      if (newTrees) {
        path([[0, 438], [42, 421], [91, 404], [103, 407]], 2);
        path([[654, 366], [687, 370], [728, 382], [774, 404]], 2);
      }
      if (!newTrees) {
        cutMove(leftTree, 45, 420, wind);
        cutMove(rightTree, 688, 367, wind * 0.7);
        cutMove(littleTree, 747, 389, wind * 1.2);
      }
      var sa = t - Math.max(state.sign, state.gust + 0.45);
      var turn = sa >= 0 && sa < 2.4 ? Math.PI * 2 * smooth(sa / 2.4) : 0;
      var signAngle = turn;
      rotateSignAroundPost(signAngle);
      drawWindows();
      drawSeasonDial(t);
      drawWind(t);
      effects.draw(ctx, {
        season: season,
        night: period === 'night',
        time: t,
        reduced: reduced.matches,
        gust: Math.abs(wind) * 25
      });
      ctx.restore();
      canvas.dataset.time = t.toFixed(2);
      canvas.dataset.night = String(state.night);
      canvas.dataset.period = period;
      canvas.dataset.season = season;
      canvas.dataset.signAngle = signAngle.toFixed(3);
    }

    function start() {
      if (!raf && houseReady && effectsReady && inView && !document.hidden) {
        raf = requestAnimationFrame(tick);
      }
    }

    function tick(now) {
      raf = 0;
      if (!houseReady || !effectsReady || !inView || document.hidden) return;
      var active = !state.paused || state.time < state.manualUntil;
      if (active) {
        if (last) state.time += Math.min((now - last) / 1000, 0.05);
        last = now;
        if (!state.paused && state.time > state.nextGust) {
          state.gust = state.time;
          state.nextGust = state.time + 12 + Math.random() * 6;
        }
      } else {
        last = 0;
      }
      draw(state.time);
      if (active) raf = requestAnimationFrame(tick);
    }

    function manual(action, text) {
      if (state.paused) state.manualUntil = state.time + 10;
      action();
      announce(text);
      last = 0;
      start();
    }

    function syncPeriod() {
      state.night = period !== 'day';
      root.classList.toggle('is-day', period === 'day');
      root.classList.toggle('is-dusk', period === 'dusk');
      root.classList.toggle('is-night', period === 'night');
      root.style.setProperty('--hut-paper', paper);
      if (light) {
        light.removeAttribute('aria-pressed');
        light.setAttribute('aria-label', HutSeasons.periodSwitchLabel(period));
      }
      if (dialHit) {
        var next = SEASONS[(SEASONS.indexOf(season) + 1) % 4];
        dialHit.setAttribute(
          'aria-label',
          '季節の切替ダイヤル。現在は' +
            SEASON_JA[season] +
            '（' +
            SEASON_EN[season] +
            '）。押すと' +
            SEASON_JA[next] +
            '（' +
            SEASON_EN[next] +
            '）に変わります。'
        );
      }
      draw(state.time);
    }

    if (light) {
      light.addEventListener('click', function () {
        periodMode = HutSeasons.nextPeriod(period);
        persistScene();
        updateSeason();
        announce(
          period === 'night'
            ? '夜になり、家の明かりが灯りました。'
            : period === 'dusk'
              ? '夕方になりました。'
              : '昼に戻りました。'
        );
      });
    }

    var smokeHit = root.querySelector('.hut-smoke-hit');
    var treeHit = root.querySelector('.hut-tree-hit');
    var signHit = root.querySelector('.hut-sign-hit');
    if (smokeHit) {
      smokeHit.addEventListener('click', function () {
        manual(function () {
          state.smoke = state.time;
        }, '煙がふわっと流れます。');
      });
    }
    if (treeHit) {
      treeHit.addEventListener('click', function () {
        manual(function () {
          state.gust = state.time;
        }, '風が吹いて木々が揺れ、看板が一回転します。');
      });
    }
    if (signHit) {
      signHit.addEventListener('click', function () {
        manual(function () {
          state.sign = state.time;
        }, 'CHAOSの看板が一回転します。');
      });
    }
    if (dialHit) {
      dialHit.addEventListener('click', function () {
        if (state.paused) state.manualUntil = state.time + 10;
        if (dialTurns === null) dialTurns = SEASONS.indexOf(season);
        dialTurns++;
        seasonMode = SEASONS[((dialTurns % 4) + 4) % 4];
        persistScene();
        // A click cancels any arrow nudge in flight and restarts the idle
        // timer after the switch rotation, so rapid clicks never desync.
        state.nudgeStart = -100;
        state.nextNudge = state.time + 7;
        updateSeason();
        announce('季節が' + SEASON_JA[season] + '（' + SEASON_EN[season] + '）に変わりました。');
        last = 0;
        start();
      });
    }

    reduced.addEventListener('change', function () {
      state.paused = reduced.matches;
      state.manualUntil = 0;
      start();
    });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        draw(state.time);
      }).observe(canvas);
    }

    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(
        function (entries) {
          inView = entries[0].isIntersecting;
          last = 0;
          if (inView) start();
        },
        { threshold: 0.02 }
      ).observe(root);
    }

    var inst = {
      syncPeriod: syncPeriod,
      resetFrameClock: function () {
        last = 0;
      },
      start: function () {
        if (houseReady && effectsReady) {
          updateSeason();
          draw(state.time);
          start();
        }
      },
      resume: function () {
        last = 0;
        if (houseReady && effectsReady && inView) start();
      }
    };

    instances.push(inst);
    return inst;
  }

  function boot() {
    var roots = document.querySelectorAll('[data-hut-living-house]');
    if (!roots.length || typeof HutSeasons === 'undefined') return;

    var sources = {};
    try {
      sources = JSON.parse(roots[0].getAttribute('data-season-assets') || '{}');
    } catch (err) {
      sources = {};
    }
    delete sources['summer-green-tree'];
    delete sources['spring-blossom'];

    house = new Image();
    house.src = roots[0].getAttribute('data-house-src');
    effects = HutSeasons.create(sources);
    roots.forEach(createInstance);

    function maybeStart() {
      if (!houseReady || !effectsReady) return;
      updateSeason();
      instances.forEach(function (inst) {
        inst.start();
      });
    }

    house.onload = function () {
      houseReady = true;
      maybeStart();
    };
    house.onerror = function () {
      document.querySelectorAll('[data-hut-living-house] .hut-sr').forEach(function (el) {
        el.textContent = '家の画像を読み込めませんでした。';
      });
    };
    if (house.complete && house.naturalWidth) {
      houseReady = true;
    }
    effects.ready.then(function () {
      effectsReady = true;
      maybeStart();
    });

    document.addEventListener('visibilitychange', function () {
      instances.forEach(function (inst) {
        inst.resetFrameClock();
      });
      if (document.hidden) return;
      updateSeason();
      instances.forEach(function (inst) {
        inst.resume();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
